import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

import Button from '@/components/Button';
import GenericFilters from '@/components/GenericFilters';
import { inventoryStatus, status } from '@/types/fulfill/inventoryHistory';
import { DeliveryType, FulfillStatus } from '@/types/fulfill/statusOrders/orders.interface';

import { FilterSection } from './utils';

export interface IFilters {
  fulfillmentStatus?: FulfillStatus[];
  deliveryType?: DeliveryType[];
  inventoryStatus?: inventoryStatus[];
  status?: status[];
  [key: string]: string[] | undefined;
}
interface ISubSection {
  width: string;
  filterName: string;
  items: Array<{ value: string }>;
  selectedFilters?: IFilters;
  onChange?: (filterName: string, value: string) => void;
}

type FiltersProps = Pick<ISubSection, 'selectedFilters' | 'onChange'> & {
  clearFilters?: () => void;
  applyFilters?: () => void;
  filters: FilterSection[];
};

const Filters = ({
  filters,
  selectedFilters,
  onChange,
  clearFilters,
  applyFilters,
}: FiltersProps) => {
  const theme = useTheme();

  const transformedFilters: Record<string, string | string[]> = selectedFilters
    ? Object.entries(selectedFilters)
        .filter(([, value]) => value !== undefined)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
    : {};

  const commonPaperStyle = {
    p: 2.5,
    mb: 2,
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'background.paper',
  };

  return (
    <Box sx={{ mt: 2, maxWidth: '100%', overflow: 'hidden' }}>
      <Paper elevation={0} sx={commonPaperStyle}>
        <GenericFilters
          filters={filters}
          selectedFilters={transformedFilters}
          handleOnChange={onChange ?? (() => {})}
          typeCheck="radio"
        />
      </Paper>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          '& > button': {
            minWidth: '140px',
            px: 3,
            py: 1,
            [theme.breakpoints.down('sm')]: { width: '100%' },
          },
        }}
      >
        <Button onClick={clearFilters} variant="outlined">
          Limpiar filtros
        </Button>
        <Button onClick={applyFilters} variant="contained">
          Aplicar filtros
        </Button>
      </Box>
    </Box>
  );
};

export default Filters;
